<!--
 * @Author: 定制状态页面
 * @Date: 2021-07-23 09:16:52
 * @LastEditTime: 2021-07-23 10:26:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kr-health-manage\src\views\prescription\PrescriptionDetails\sport\customize\index.vue
-->
<template>
  <div class="customize">
    <img src="@/assets/img/end.png" alt="" />
    <span @click="changeShowPrescription">去定制你的运动计划</span>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
    },
  },
  methods: {
    changeShowPrescription() {
      this.$router.push({
        path: "/sportPrescriptionDetails",
        query: { time: this.time },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.customize {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0.2rem 0;
  }
  span {
    width: 3rem;
    height: 0.7rem;
    line-height: 0.7rem;

    border-radius: 0.1rem;
    background: cornflowerblue;
    font-size: 0.25rem;
    text-align: center;
    color: #fff;
  }
}
</style>
